import './style.scoped.css';

const CardInfoItem = (props) => {
  const { title, info } = props;
  return (
    <div className="card">
      <div className="pb-4 text-base font-bold text-onSurface border-b border-line">
        {title}
      </div>
      <div className="infoText">{info}</div>
    </div>
  );
};

export default CardInfoItem;
